import { DOCUMENT } from 'entities/user/module'

export interface TouristValues {
  id?: string
  lastName: string
  firstName: string
  middleName?: string
  gender?: string
  dateOfBirth: Date | string
  citizenship: string
  documentType: string
  serialDocuments?: string
  documentExpirationDate?: string
  documentGivenDate?: string
  pin?: string
}

export const InnLength = 14
export const MinFiledLength = 2
export const MaxFiledLength = 30

export const listPassportsTour = [
  {
    name: 'passport',
    value: DOCUMENT.PASSPORT,
  },
]
